"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var CardRowButtonTextEditor_1 = require("../../../../../../shared/components/editors/CardRowButtonTextEditor");
var BrandBannerEditor = /** @class */ (function (_super) {
    __extends(BrandBannerEditor, _super);
    function BrandBannerEditor(props) {
        return _super.call(this, props) || this;
    }
    BrandBannerEditor.prototype.getPriorityAvail = function () {
        var _ret = [];
        for (var i = 1; i <= 10; i++) {
            _ret.push({
                key: i,
                value: "\u041D\u043E\u043C\u0435\u0440-" + i,
            });
        }
        return _ret;
    };
    BrandBannerEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    banner_url: _item.banner_url,
                    geometry_type_code: _item.geometry_type_code,
                    geometry_type_title: _item.geometry_type_title,
                    image_type_code: _item.image_type_code,
                    image_type_title: _item.image_type_title,
                    width: _item.width,
                    height: _item.height,
                    is_deprecated: _item.is_deprecated,
                    is_all_country: _item.is_all_country,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title,
                    order_number_key: _item.order_number,
                    order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + _item.order_number,
                    order_number_avail: this.getPriorityAvail()
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Редактирование баннера"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                banner_url: "",
                geometry_type_code: 0,
                geometry_type_title: "",
                image_type_code: 0,
                image_type_title: "",
                width: 10,
                height: 10,
                is_deprecated: false,
                is_all_country: false,
                brand_id: 0,
                brand_title: "",
                order_number_key: 1,
                order_number_val: "\u041D\u043E\u043C\u0435\u0440-" + 1,
                order_number_avail: this.getPriorityAvail()
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создание баннера"]);
            });
        }
        this.doReSetRules();
    };
    BrandBannerEditor.prototype.doReSetRules = function () {
        this.setState({
            banner_url_rules: { isError: false },
            geometry_type_rules: { isError: false },
            title_rules: { isError: false },
            image_type_rules: { isError: false },
            width_rules: { isError: false },
            height_rules: { isError: false },
            brand_rules: { isError: false },
            order_number_rules: { isError: false }
        });
    };
    BrandBannerEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((!this.state.banner_url) || (this.state.banner_url.length === 0)) {
            this.setState({ banner_url_rules: { isError: true, errorMessage: "Поле [banner url] не выбрано!" } });
            return false;
        }
        if ((this.state.geometry_type_code <= 0) || (!this.state.geometry_type_title) || (this.state.geometry_type_title.length === 0)) {
            this.setState({ geometry_type_rules: { isError: true, errorMessage: "Поле [геометрия] не выбрано!" } });
            return false;
        }
        if ((this.state.image_type_code <= 0) || (!this.state.image_type_title) || (this.state.image_type_title.length === 0)) {
            this.setState({ image_type_rules: { isError: true, errorMessage: "Поле [формат] не выбрано!" } });
            return false;
        }
        if ((this.state.brand_id <= 0) || (!this.state.brand_title) || (this.state.brand_title.length === 0)) {
            this.setState({ brand_rules: { isError: true, errorMessage: "Поле [бренд] не выбрано!" } });
            return false;
        }
        if ((this.state.width <= 0) || (this.state.width > 65535)) {
            this.setState({ width_rules: { isError: true, errorMessage: "Поле [ширина] некорректно!" } });
            return false;
        }
        if ((this.state.height <= 0) || (this.state.height > 65535)) {
            this.setState({ height_rules: { isError: true, errorMessage: "Поле [высота] некорректно!" } });
            return false;
        }
        if ((this.state.order_number_key <= 0) || (this.state.order_number_val.length === 0)) {
            this.setState({ order_number_rules: { isError: true, errorMessage: "Поле [Порядковый номер] не выбрано!" } });
            return false;
        }
        return true;
    };
    BrandBannerEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                banner_url: this.state.banner_url,
                geometry_type_code: this.state.geometry_type_code,
                image_type_code: this.state.image_type_code,
                width: this.state.width,
                height: this.state.height,
                is_deprecated: this.state.is_deprecated,
                is_all_country: this.state.is_all_country,
                order_number: this.state.order_number_key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Баннер изменен!");
            });
        }
    };
    BrandBannerEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                brand_id: this.state.brand_id,
                title: this.state.title,
                banner_url: this.state.banner_url,
                geometry_type_code: this.state.geometry_type_code,
                image_type_code: this.state.image_type_code,
                width: this.state.width,
                height: this.state.height,
                is_deprecated: this.state.is_deprecated,
                is_all_country: this.state.is_all_country,
                order_number: this.state.order_number_key
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Баннер добавлен!");
            });
        }
    };
    BrandBannerEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandBannerEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Добавить баннер";
        }
        else {
            return "Изменить баннер";
        }
    };
    BrandBannerEditor.prototype.DoShowSelectImageDialog = function () {
        var _this = this;
        this.props.dialogSelectImage.SetDialogTitle("Выбор изображения").SetOnSelect(function (brandIdentity, dirName, fileName) {
            _this.setState({ banner_url: brandIdentity + "/" + dirName + "/" + fileName }, function () {
                _this.props.dialogSelectImage.Close();
            });
        }).Show();
    };
    BrandBannerEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 680 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Бренд:", placeholder: "Выберите бренд баннера" }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.brandsAvail, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Порядковый номер:", placeholder: "Выберите порядковый номер" }, value: { key: this.state.order_number_key, value: this.state.order_number_val }, onValueChanged: function (newVal) {
                    _this.setState({
                        order_number_key: newVal.key,
                        order_number_val: newVal.value,
                        order_number_rules: { isError: false }
                    });
                }, items: this.state.order_number_avail, required: true, rules: this.state.order_number_rules }),
            React.createElement(CardRowButtonTextEditor_1.default, { texts: {
                    caption: "Изображение:",
                    placeholder: "Выберите изображение",
                    buttonHint: "Выберите изображение"
                }, readonly: true, onButtonClick: this.DoShowSelectImageDialog.bind(this), onValueChanged: function (newVal) {
                    _this.setState({
                        banner_url: newVal,
                        banner_url_rules: { isError: false }
                    });
                }, value: this.state.banner_url, buttonIcon: "search", required: true, rules: this.state.banner_url_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Геометрия баннера:", placeholder: "Выберите геометрию баннера" }, value: { key: this.state.geometry_type_code, value: this.state.geometry_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        geometry_type_code: newVal.key,
                        geometry_type_title: newVal.value,
                        geometry_type_rules: { isError: false }
                    });
                }, items: this.props.bannerGeometryAvail, disabled: false, required: true, rules: this.state.geometry_type_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Формат баннера:", placeholder: "Выберите формат баннера" }, value: { key: this.state.image_type_code, value: this.state.image_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        image_type_code: newVal.key,
                        image_type_title: newVal.value,
                        image_type_rules: { isError: false }
                    });
                }, items: this.props.bannerFormatsAvail, disabled: false, required: true, rules: this.state.image_type_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Ширина:", placeholder: "Введите ширину баннера" }, values: { max: 65535, min: 1, value: this.state.width }, onValueChanged: function (newVal) {
                    _this.setState({
                        width: newVal,
                        width_rules: { isError: false }
                    });
                }, required: true, rules: this.state.width_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Высота:", placeholder: "Введите высоту баннера" }, values: { max: 65535, min: 1, value: this.state.height }, onValueChanged: function (newVal) {
                    _this.setState({
                        height: newVal,
                        height_rules: { isError: false }
                    });
                }, required: true, rules: this.state.height_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Устарел", value: this.state.is_deprecated, onChecked: function (checked) {
                    _this.setState({
                        is_deprecated: checked
                    });
                } }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Все страны", value: this.state.is_all_country, onChecked: function (checked) {
                    _this.setState({
                        is_all_country: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return BrandBannerEditor;
}(React.Component));
exports.default = BrandBannerEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_brands_banners_list/ui/component/BrandBannerEditor.tsx
// module id = 2407
// module chunks = 0